import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { supabase } from '../lib/supabase.ts';
import { Betolto, Fokonyv, Gomb, HibaUzenet, Mezo, OldalFej, Ures } from '../ui/elemek.tsx';

export default function SuperIrodak() {
  const [kereses, setKereses] = useState('');
  const navigate = useNavigate();
  const lista = useQuery({
    queryKey: ['super-irodak'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('offices')
        .select('id, nev, slug, halozat, varos, aktiv, tagok:office_members(count)')
        .order('nev');
      if (error) throw error;
      return data;
    },
  });

  const szuro = kereses.trim().toLowerCase();
  const sorok = (lista.data ?? []).filter((i) => szuro === '' || i.nev.toLowerCase().includes(szuro) || i.slug.includes(szuro));

  return (
    <div className="grid gap-4">
      <OldalFej cim="Irodák" leiras="Az összes iroda, a tagok száma és az oldal állapota.">
        <Gomb onClick={() => void navigate('/super/irodak/uj')}>Új iroda</Gomb>
      </OldalFej>
      <Mezo label="Keresés névre vagy slugra" value={kereses} onChange={(e) => setKereses(e.target.value)} />
      <HibaUzenet hiba={lista.error} />
      {lista.isPending && <Betolto />}
      {lista.data && sorok.length === 0 && <Ures cim="Nincs találat" szoveg="Nincs a keresésnek megfelelő iroda." />}
      {sorok.length > 0 && (
        <Fokonyv>
          <ul className="divide-y divide-vonal">
            {sorok.map((i) => (
              <li key={i.id}>
                <Link to={`/super/irodak/${i.id}`} className="flex min-h-14 flex-wrap items-center justify-between gap-x-4 gap-y-1 px-5 py-3.5 hover:bg-felulet">
                  <span className="grid min-w-0">
                    <span className="truncate font-semibold">{i.nev}</span>
                    <span className="truncate text-sm text-szoveg-halk">/{i.slug}{[i.halozat, i.varos].filter(Boolean).map((r) => `, ${r}`).join('')}</span>
                  </span>
                  <span className="flex items-center gap-2 text-sm">
                    <span className="text-szoveg-halk">{i.tagok[0]?.count ?? 0} tag</span>
                    <span className={`inline-flex items-center gap-1.5 ${i.aktiv ? 'text-kiemelt' : 'text-szoveg-halk'}`}><span aria-hidden className="size-[7px] rounded-full bg-current" />{i.aktiv ? 'Aktív' : 'Inaktív'}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </Fokonyv>
      )}
    </div>
  );
}
